import React from 'react';

import { Button, Text } from 'v3/components';

const pendingLabels = {
  startAnalysis: 'Pegando para análise...',
  approveData: 'Aprovando...',
  approveEmission: 'Aprovando...',
  reject: 'Reprovando...',
  reopen: 'Voltando para análise...',
};

function ActionButton({
  name,
  label,
  variant,
  color = 'white',
  pending,
  onClick,
  outlined,
  size,
  testIdPrefix = 'action',
}) {
  return (
    <Button
      variant={variant}
      outlined={outlined}
      size={size}
      disabled={!!pending}
      onClick={onClick}
      data-testid={`${testIdPrefix}-${name}`}
    >
      <Text weight={500} color={color} type="regular">
        {pending === name ? pendingLabels[name] : label}
      </Text>
    </Button>
  );
}

export default function StatusActions({
  actions = [],
  pending = null,
  onBack,
  onStartAnalysis,
  onApproveData,
  onApproveEmission,
  onReject,
  onReopen,
}) {
  const has = (name) => actions.includes(name);

  return (
    <div className="d-flex justify-content-end mt-3 mb-4" style={{ gap: '0.75rem' }}>
      <Button variant="white" outlined onClick={onBack}>
        <Text weight={500} type="regular">
          Voltar
        </Text>
      </Button>
      {has('reject') && (
        <ActionButton
          name="reject"
          label="Reprovar"
          variant="error"
          pending={pending}
          onClick={onReject}
        />
      )}
      {has('reopen') && (
        <ActionButton
          name="reopen"
          label="Voltar para análise"
          variant="primary"
          pending={pending}
          onClick={onReopen}
        />
      )}
      {has('startAnalysis') && (
        <ActionButton
          name="startAnalysis"
          label="Pegar para analisar"
          variant="primary"
          pending={pending}
          onClick={onStartAnalysis}
        />
      )}
      {has('approveData') && (
        <ActionButton
          name="approveData"
          label="Aprovar"
          variant="success"
          pending={pending}
          onClick={onApproveData}
        />
      )}
      {has('approveEmission') && (
        <ActionButton
          name="approveEmission"
          label="Aprovar"
          variant="success"
          pending={pending}
          onClick={onApproveEmission}
        />
      )}
    </div>
  );
}

// Atalhos no cabeçalho do painel de status, ao lado de Auditoria.
export function HeaderStatusActions({ actions = [], pending = null, onStartAnalysis, onReject }) {
  const has = (name) => actions.includes(name);

  return (
    <>
      {has('reject') && (
        <ActionButton
          name="reject"
          label="Reprovar"
          variant="error"
          size="sm"
          testIdPrefix="header-action"
          pending={pending}
          onClick={onReject}
        />
      )}
      {has('startAnalysis') && (
        <ActionButton
          name="startAnalysis"
          label="Pegar para analisar"
          variant="primary"
          size="sm"
          testIdPrefix="header-action"
          pending={pending}
          onClick={onStartAnalysis}
        />
      )}
    </>
  );
}
